import { apiService } from "../../ApiService";
import { StripeInvoice } from "../../../model";

export interface stripeGetInvoicesInterface {
  invoices: StripeInvoice[];
  meta: {
    total: number;
    offset: number;
    limit: number;
    page: number;
    next: number;
    totalPages: number;
  };
}

export const stripeGetInvoices = (page = 1, limit?: number) =>
  apiService.get<stripeGetInvoicesInterface>({
    path: `public/account/invoices`,
    params: {
      page,
      limit,
    },
    crm: true,
  });
